import React from 'react';
import Icon from 'components/icon';
import $ from 'jquery';
import { string, shape } from 'prop-types';

const downloadClick = (item, e) => {
    e.preventDefault();
    const fileData = {
        pageName: item.title,
        fileName: item.url.split('/').pop(),
        fileUrl: item.url
    };
    $.ajax({
        cache: false,
        type: 'POST',
        crossDomain: true,
        dataType: 'json',
        url: '/api/PdfDownload/StorePdfDownloadActivity',
        data: fileData
    });
    window.location.href = item.url;
};

export default function BrochureListingTile({ item, downloadText }) {
    return (
        <a href={item.url} onClick={e => downloadClick(item, e)} className="c-base-tile c-listing-tile c-brochure-listing-tile">
            <div className="tile-content">
                <div className="tile-thumbnail">
                    <img src={item.thumbnail} alt={item.title} />
                </div>

                <div className="tile-description">
                    <div className="language">{item.language}</div>
                    <div className="title" title={item.title}>{item.title}</div>
                    <div className="region">{item.regions}</div>
                    <div className="cta">{downloadText} <Icon glyph="download" /></div>
                </div>
            </div>
        </a>
    );
}


BrochureListingTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        thumbnail: string,
        title: string.isRequired,
        language: string,
        region: string
    }).isRequired,
    downloadText: string.isRequired
    /* eslint-enable react/no-typos */
};
